"use client";

import { useMutation } from "@tanstack/react-query";

export const useSetLastCartId = () =>
  useMutation({
    mutationFn: async (body: { cartId: string | null }) => {
      const response = await fetch("/api/user/last-cart-id", {
        method: "PATCH",
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Failed to set lastCartId: ${response.status}`);
      }

      return body.cartId;
    },
  });
